module.exports = __webpack_public_path__ + "img/banner.253a529d.png";